import { render, staticRenderFns } from "./CustomSelectBox.vue?vue&type=template&id=df20c16c"
import script from "./CustomSelectBox.vue?vue&type=script&lang=js"
export * from "./CustomSelectBox.vue?vue&type=script&lang=js"
import style0 from "./CustomSelectBox.vue?vue&type=style&index=0&id=df20c16c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports